"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = _interopRequireDefault(require("@/components/ispAmountInput/index.vue"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _validators = _interopRequireDefault(require("@/components/Validate/validators"));
var _user = require("@/api/system/user");
var _auth = require("@/utils/auth");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "ChangePassword",
  components: {
    dragDialog: _DragDialog.default,
    amountInput: _index.default
  },
  props: {},
  data: function data() {
    var _this = this;
    var validatePassword = function validatePassword(rule, value, callback) {
      var passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#￥%&])[A-Za-z\d!@#￥%&]{8,30}$/;
      if (!value || value.length === 0) {
        callback(new Error(_this.$t('login.passwordRequire')));
      }
      if (!passwordPattern.test(value)) {
        callback(new Error(_this.$t('home.messagePass')));
      } else {
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$t('home.messageOne')));
      } else if (value !== _this.form.password) {
        callback(new Error(_this.$t('home.messageTwo')));
      } else {
        callback();
      }
    };
    return {
      form: {
        password: '',
        passwordConfirm: ''
      },
      rules: {
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }, {
          validator: _validators.default.length({
            max: 30,
            title: this.$t('ebSysAccount.password')
          }),
          trigger: 'blur'
        }],
        passwordConfirm: [{
          required: true,
          validator: validatePass2,
          trigger: 'blur'
        }]
      },
      loading: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    opened: function opened() {},
    closed: function closed() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.$refs['form'].clearValidate();
      });
    },
    handleSave: function handleSave() {
      var _this3 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this3.loading = (0, _utils.load)();
          (0, _user.updateOldSystemPassword)(_this3.userInfo.accountNo, btoa(_this3.form.password)).then(function (res) {
            _this3.loading.close();
            if (res.success) {
              var userInfo = sessionStorage.getItem("userInfo") && JSON.parse(sessionStorage.getItem("userInfo"));
              if (userInfo) {
                userInfo.registUser = 3;
                sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
              }
              (0, _auth.removeToken)();
              _this3.$confirm(_this3.$t('home.modifyPasswordSuccess'), _this3.$t('confirmMsg.title'), {
                confirmButtonText: _this3.$t('confirmMsg.confirm'),
                showCancelButton: false,
                showClose: false,
                closeOnPressEscape: false,
                closeOnClickModal: false,
                type: 'warning'
              }).then(function () {
                _this3.logout();
              });
            } else {
              var errorMessages = res.errorMessages && res.errorMessages[0];
              if (!errorMessages) {
                errorMessages = _this3.$t('contract.failMessage');
              }
              _this3.$message({
                message: errorMessages,
                type: 'warning'
              });
            }
          }).catch(function () {
            _this3.loading.close();
          });
        }
      });
    },
    logout: function logout() {
      // 退出登录后清除用户权限
      this.$store.dispatch('user/logoutAuth');
      this.$router.push({
        path: '/home'
      });
    }
  }
};